import React from "react";
import { Helmet } from "react-helmet";

const FAQPageSchema = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is AI Hairstyle Studio?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "AI Hairstyle Studio is a virtual hair salon that uses AI technology to let you try on different hairstyles, haircuts, and colors instantly."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost to use AI Hairstyle Studio?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "AI Hairstyle Studio is completely free to use."
        }
      },
      {
        "@type": "Question",
        "name": "Can I save the hairstyles I try on?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, you can save and share the hairstyles you try on directly from the platform."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need to create an account to use AI Hairstyle Studio?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, you can use the platform without creating an account, but signing up allows you to save your preferences."
        }
      }
    ]
  };

  return (
    <Helmet>
      <title>AI Hairstyle Studio </title>
      <meta
        name="description"
        content="Find answers to frequently asked questions about AI Hairstyle Studio, a virtual hair salon powered by AI technology."
      />
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default FAQPageSchema;
